<template>
  <div>
    <span
      class="high-risk-badge"
      :class="count > 0 ? 'high-risk-badge--danger' : 'high-risk-badge--none'"
    >
      {{ count }}
    </span>
  </div>
</template>
<script>
export default {
  props: ["item"],
  computed: {
    count() {
      const areas = (this.item && this.item.areas) || [];
      return areas.reduce(
        (sum, area) =>
          sum +
          (area.tasks || []).filter((t) => Number(t.riskClassification) >= 5)
            .length,
        0
      );
    },
  },
};
</script>
<style scoped>
.high-risk-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  border: 1.5px solid currentColor;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}
.high-risk-badge--danger {
  color: #c0392b;
}
.high-risk-badge--none {
  color: rgba(0, 0, 0, 0.35);
}
</style>
